import { gql } from '@apollo/client';

const entitlementDetailsForTxa = gql`
  fragment entitlementDetailsForTxa on TransactionAccountProduct {
    billingFrequency
    entitlementNumber
    transactionAccountNumber
    latestPeriodEndDate
    latestPeriodStartDate
    productId
    productName
    baseProduct
    billingStatus
    edition
    cloudSiteHostname
    provisioningStatus
    billingGroupId
    id
    billedUsers
    trial
    isSandbox
    activeUsers
    isApp
    nextBillingTimestamp
    logoId
    userTier
    trialEndDate
    endTimestamp
    offeringId
    pricingPlanId
    pricingPlan {
      type
      billingFrequency
      id
      currency
      pricingPlanType
      status
      description
      tiers {
        unitAmount
        flatAmount
        floor
        ceiling
      }
    }
    upgradeTrial {
      offeringName
      offeringId
      baseOfferingName
    }
    scheduledChanges {
      subscriptionScheduleAction
    }
    relatesFromEntitlements {
      entitlementId
      relationshipType
    }
    version
  }
`;

const productAppSubscriptionForTxa = gql`
  ${entitlementDetailsForTxa}
  fragment productAppSubscriptionForTxa on ProductAppSubscription {
    products {
      ...entitlementDetailsForTxa
    }
    apps {
      ...entitlementDetailsForTxa
    }
  }
`;

export const fetchProductAppSubscriptionsForTransactionAccount = gql`
  ${productAppSubscriptionForTxa}
  query fetchProductAppSubscriptionsForTransactionAccount(
    $id: ID!
    $filterOptions: [FilterOption]
    $searchOptions: ConnectionSearchOptions
  ) {
    transactionAccount(id: $id) {
      productAndAppSubscriptions(filterOptions: $filterOptions, searchOptions: $searchOptions) {
        jira {
          ...productAppSubscriptionForTxa
        }
        statuspage {
          ...productAppSubscriptionForTxa
        }
        confluence {
          ...productAppSubscriptionForTxa
        }
        other {
          ...productAppSubscriptionForTxa
        }
      }
    }
  }
`;

const entitlementDetailsForBillingProfile = gql`
  fragment entitlementDetailsForBillingProfile on InvoiceGroupProduct {
    billingGroupId
    billingFrequency
    entitlementNumber
    id
    latestPeriodEndDate
    latestPeriodStartDate
    productId
    productName
    baseProduct
    billingStatus
    edition
    cloudSiteHostname
    provisioningStatus
    billedUsers
    trial
    isSandbox
    isApp
    activeUsers
    nextBillingTimestamp
    userTier
    logoId
    endTimestamp
    trialStartDate
    trialEndDate
    upgradeTrial {
      offeringName
      offeringId
      baseOfferingName
    }
    scheduledChanges {
      subscriptionScheduleAction
    }
  }
`;

const productAppSubscriptionForBillingProfile = gql`
  ${entitlementDetailsForBillingProfile}
  fragment productAppSubscriptionForBillingProfile on ProductAppSubscriptionForInvoiceGroup {
    products {
      ...entitlementDetailsForBillingProfile
    }
    apps {
      ...entitlementDetailsForBillingProfile
    }
  }
`;

export const fetchProductAppSubscriptionsForBillingProfile = gql`
  ${productAppSubscriptionForBillingProfile}
  query fetchProductAppSubscriptionsForBillingProfile($id: ID!, $filterOptions: [FilterOption]) {
    invoiceGroup(id: $id) {
      productAndAppSubscriptions(filterOptions: $filterOptions) {
        jira {
          ...productAppSubscriptionForBillingProfile
        }
        statuspage {
          ...productAppSubscriptionForBillingProfile
        }
        confluence {
          ...productAppSubscriptionForBillingProfile
        }
        other {
          ...productAppSubscriptionForBillingProfile
        }
      }
    }
  }
`;
